import { http } from "@/http";
import { StudyInfo } from "@/psychlab/types";

export const getStudyInfo = async(id:string):Promise<StudyInfo> => {
	const { data } = await http.get(`studies/${id}/info`);
	return data;
};